import { SolutionsSections, defaultSolutionsContent } from "@quintara/site-kit";
import { usePageMeta } from "../usePageMeta";
import { useCmsContent } from "../useCmsContent";

export function Solutions() {
  const content = useCmsContent("solutions", defaultSolutionsContent);
  usePageMeta(content.meta.title, content.meta.description);
  return <SolutionsSections content={content} />;
}
